import "./styles.css";
import { Game } from "./game/Game";

try {
  new Game();
} catch (error) {
  console.error("SOL ROLLER failed to initialize", error);
  const app = document.getElementById("app");
  const intro = document.getElementById("intro");
  const message = document.querySelector(".intro-copy p");
  if (app) {
    app.dataset.ready = "error";
  }
  if (intro) {
    intro.classList.remove("hidden");
  }
  if (message) {
    message.textContent = "WebGL 3Dの初期化に失敗しました。対応ブラウザでハードウェアアクセラレーションを有効にして再読み込みしてください。";
  }
}
